import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  type?: string;
  leftComponent?: React.ReactNode;
}

export const Input: React.FC<InputProps> = ({
  label,
  error,
  type = 'text',
  leftComponent,
  className = '',
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const isPassword = type === 'password';
  const inputType = isPassword ? (showPassword ? 'text' : 'password') : type;

  return (
    <div className="space-y-1.5 w-full">
      {label && (
        <label className="block text-[11px] font-bold text-slate-500 uppercase tracking-[0.08em]">
          {label}
        </label>
      )}
      <div className="relative flex">
        {leftComponent && (
          <div className="absolute left-0 top-0 bottom-0 z-10">
            {leftComponent}
          </div>
        )}

        <input
          type={inputType}
          className={`
            w-full px-4 py-3.5 rounded-xl border outline-none transition-all text-sm leading-relaxed
            placeholder:text-slate-400 text-slate-900 font-medium
            ${error
              ? 'border-error focus:border-error focus:ring-1 focus:ring-error'
              : 'border-slate-300 focus:border-primary focus:ring-1 focus:ring-primary'}
            ${leftComponent ? 'pl-0' : ''}
            ${isPassword ? 'pr-12' : ''}
            ${className}
          `}
          {...props}
        />

        {isPassword && (
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600 transition-colors"
          >
            {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
          </button>
        )}
      </div>
      {error && <p className="text-xs text-error font-medium mt-1">{error}</p>}
    </div>
  );
};
